import { NextSeo } from 'next-seo';
import { useIntl } from 'react-intl';

import { Banner } from '@/core/components/Layout/Banner';
import { MarginWrapper } from '@/core/components/MarginWrapper';
import { Breadcrumbs } from '@/core/components/Breadcrumbs';
import {
  Subheader,
  Title,
  TitleWrapper,
} from '@/core/components/PageLayout';
import { Section } from '@/core/components/Section';
import { navigationMessages } from '@/core/messages/navigation.messages';
import { useLocalizedOGTitle } from '@/core/hooks/useLocalizedOGTitle';

import {
  getBackendImage,
  getKeywordsProps,
} from '@/utils/helpers';

import { AboutPageData } from './About.types';
import { Wrapper } from './About.styles';

type AboutPageProps = {
  aboutData: AboutPageData;
}

export const AboutPage = ({ aboutData }: AboutPageProps) => {
  const { formatMessage } = useIntl();
  const {
    banner,
    header,
    sections,
    meta,
  } = aboutData;

  const OGTitle = useLocalizedOGTitle(
    meta?.OGTitle || meta?.title || formatMessage(navigationMessages.about)
  );

  return (
    <>
      <NextSeo
        title={meta?.title || formatMessage(navigationMessages.about)}
        description={meta?.description || ''}
        openGraph={{
          description: meta?.OGDescription || meta?.description || '',
          title: OGTitle,
        }}
        {...getKeywordsProps(meta?.keywords)}
      />
      <Banner
        TitleText={banner.header}
        Image={getBackendImage(banner?.banner?.data?.attributes?.url)}
        SubtitleText={banner.paragraph}
      />
      <Breadcrumbs />
      <Wrapper>
        <MarginWrapper>
          <TitleWrapper>
            <Subheader>{header.subtitle}</Subheader>
            <Title>{header.title}</Title>
          </TitleWrapper>
        </MarginWrapper>
      </Wrapper>
      {sections.map(section => (
        <Section
         // eslint-disable-next-line no-underscore-dangle
          key={section.__component}
          {...section}
        />
      ))}
    </>
  );
};
